import PropTypes from 'prop-types';
import { CurrencyNumberPropType } from '../../../services/proptypes';
import { PRICE_DISPLAY_TYPES, FIRST_PRICE_DISPLAY_TYPE, DEFAULT_LABEL_DELIMITER, DEFAULT_RANGE_DELIMITER, DEFAULT_STARTING_AT_APPENDIX } from '../constants';
export var PricePropType = PropTypes.shape({
  amount: CurrencyNumberPropType
});
export var PricePropTypeDefault = {
  amount: ''
};
export var PriceSettingsPropType = PropTypes.shape({
  displayZeroCost: PropTypes.bool,
  precision: PropTypes.number,
  hideCurrencySign: PropTypes.bool,
  hide: PropTypes.bool
});
export var PriceSettingsPropTypeDefault = {
  displayZeroCost: true,
  precision: 2,
  hideCurrencySign: false,
  hide: false
};
export var PriceRangeSettingsPropType = PropTypes.shape({
  displayZeroCost: PropTypes.bool,
  precision: PropTypes.number,
  displayType: PropTypes.oneOf(PRICE_DISPLAY_TYPES),
  labelDelimiter: PropTypes.string,
  rangeDelimiter: PropTypes.string,
  startingAtAppendix: PropTypes.string,
  allowMixedFormats: PropTypes.bool,
  hideCurrencySign: PropTypes.bool,
  hide: PropTypes.bool
});
export var PriceRangeSettingsPropTypeDefault = {
  displayZeroCost: true,
  precision: 2,
  displayType: FIRST_PRICE_DISPLAY_TYPE,
  labelDelimiter: DEFAULT_LABEL_DELIMITER,
  rangeDelimiter: DEFAULT_RANGE_DELIMITER,
  startingAtAppendix: DEFAULT_STARTING_AT_APPENDIX,
  allowMixedFormats: false,
  hideCurrencySign: false,
  hide: false
};